import Link from '~/shared/components/link';
import { getLocaleLink } from '~/shared/helpers/browser-helpers';
import { getUrl } from '~/shared/helpers/string-helpers';
import type { ItemDataType } from '~/shared/types/general-type';
import type { I18nextOptionsType } from '~/shared/types/i18n-type';

import '~/shared/components/items-navigator/components/tile-item/tile-item.scss';

import noImage from '~/assets/no-image.webp';

type TileItemPropsType = {
  data: ItemDataType;
  pageToGo: string;
  pageTagsToGo?: string;
  t: (key: string, options: I18nextOptionsType) => string;
};

const TileItem = ({ data, lng, pageToGo }: TileItemPropsType) => (
  <article className="tile-item">
    <link itemProp="image" href={data?.thumbnail?.path ?? noImage.src} />
    <div
      itemProp="blogPosts"
      itemScope
      itemType="http://schema.org/BlogPosting"
      className="tile-item__image"
      style={{
        background: `url(${data?.thumbnail?.path ?? noImage.src}) center/cover no-repeat`,
      }}
    />
    <div className="tile-item__content">
      <Link itemProp="url" href={getLocaleLink(getUrl({ link: pageToGo, alias: data?.alias }), lng)}>
        <h4 itemProp="headline" className="tile-item__title">
          {data?.name}
        </h4>
      </Link>
      <p
        itemProp="description"
        className="tile-item__text"
        suppressHydrationWarning
        dangerouslySetInnerHTML={{ __html: data?.description }}
      />
    </div>
  </article>
);

export default TileItem;
